<template>
  <div class="row">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_icon_p">
      <img :src="app_root + '/assets/common/img/install_colorionenga.png'">
    </div>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 app_badge">
      <p class="app_title">
        <LabelFunMessage fcontId="0" msgkey="175" />
      </p>

      <a v-on:click="trackGa4AppDownloadEvent()" :href="dynamicURL_Apple" target="itunes_store">
        <img :src="app_root + '/assets/common/img/button/Download_on_the_App_Store_Badge_US-UK_135x40.svg'"
          class="app_store">
      </a>

      <a v-on:click="trackGa4AppDownloadEvent()" :href="dynamicURL_Google" target="_blank">
        <img :src="app_root + '/assets/common/img/button/google-play-badge.png'" class="google_play">
      </a>

      <p class="dl_site"><span class="glyphicon glyphicon-info-sign"></span>
        <LabelFunMessage fcontId="0" msgkey="12" />
      </p>
      <p>
        <AppCompatiblePrinters appName="nenga" />
      </p>
    </div>
  </div>
</template>

<script>
import LabelFunMessage from "./LabelFunMessage";
import AppCompatiblePrinters from "./AppCompatiblePrinters";

export default {
  name: "AppDownloadColorioNenga",
  components: {
    LabelFunMessage, AppCompatiblePrinters
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    fcontId: function () {
      if (this.$route.path.match(/\/\d+/) == null) {
        return "other"
      } else {
        return this.$route.path.match(/\/\d+/).shift().slice(1)
      }
    },
    dynamicURL_Apple() {
      return `https://apps.apple.com/jp/app/id1039733739?pt=280580&ct=fcont_${this.fcontId}&mt=8`;
    },
    dynamicURL_Google() {
      return `https://play.google.com/store/apps/details?id=com.epson.nenga&utm_source=gallery&utm_campaign=fcont_${this.fcontId}&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1
`;
    },

  },
  methods: {
    trackGa4AppDownloadEvent: function () {
      this.$gtag.event("app_download", {
        "app_name": "Colorio Nenga",
        "location_id": "article",
        "article_no": this.fcontId,
        "site_id": "gallery"
      })
    }
  }
};
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>